import React from 'react';
import { Grid } from 'components/ui';

import Card from './Card';
import List from './List';

const WithdrawalPayouts = () => (
  <Grid.Row>
    <Grid.Col>
      <Card />
    </Grid.Col>
    <Grid.Col>
      <List />
    </Grid.Col>
  </Grid.Row>
);

export default WithdrawalPayouts;
